// extracted by mini-css-extract-plugin
export default {"card":"HorizontalCard_card__d5CT1","cardSelected":"HorizontalCard_cardSelected__KdpNA","text":"HorizontalCard_text__Brn+z"};